import React, { useState } from 'react';

export default function DataSourceBar({ segments, activeCount, maxCount, isS1Only }) {
  const [tooltipId, setTooltipId] = useState(null);

  const labelColor = activeCount >= 3 ? '#4ade80' : '#fbbf24'; // green-400 / amber-400

  return (
    <div
      style={{
        background: 'rgba(255,255,255,0.05)',
        backdropFilter: 'blur(12px)',
        border: '1px solid rgba(255,255,255,0.1)',
        borderRadius: 16,
        padding: '16px 20px',
        maxWidth: 1000,
        margin: '0 auto 18px',
      }}
      onClick={e => {
        // Close tooltip when clicking container background
        if (e.target === e.currentTarget) setTooltipId(null);
      }}
    >
      {/* Label */}
      <div style={{
        fontSize: 11,
        fontWeight: 600,
        color: labelColor,
        letterSpacing: '0.04em',
        marginBottom: 10,
      }}>
        Datenbasis: {activeCount} von {maxCount} Signalquellen aktiv
      </div>

      {/* Segment bar */}
      <div style={{ display: 'flex', gap: 3, position: 'relative' }}>
        {(segments || []).map(seg => {
          const isActive = seg.active;
          const segId = seg.id || seg.key;
          const segName = seg.name || seg.label;
          const isTooltipOpen = tooltipId === segId;
          return (
            <div
              key={segId}
              style={{
                flex: 1,
                position: 'relative',
              }}
            >
              <div
                onClick={e => {
                  e.stopPropagation();
                  if (isActive) {
                    setTooltipId(null);
                  } else {
                    setTooltipId(isTooltipOpen ? null : segId);
                  }
                }}
                style={{
                  height: 40,
                  borderRadius: 4,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: 10,
                  fontWeight: 600,
                  letterSpacing: '0.02em',
                  cursor: isActive ? 'default' : 'pointer',
                  transition: 'background 0.15s',
                  background: isActive ? 'rgba(37,99,235,0.8)' : 'rgba(255,255,255,0.1)',
                  color: isActive ? '#fff' : 'rgba(255,255,255,0.35)',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  padding: '0 6px',
                }}
              >
                {segName}
              </div>

              {/* Tooltip */}
              {isTooltipOpen && (
                <div style={{
                  position: 'absolute',
                  top: '100%',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  marginTop: 6,
                  background: '#111827',
                  color: '#fff',
                  fontSize: 11,
                  padding: '8px 12px',
                  borderRadius: 8,
                  whiteSpace: 'normal',
                  width: 200,
                  zIndex: 10,
                  lineHeight: 1.5,
                  boxShadow: '0 4px 16px rgba(0,0,0,0.4)',
                  border: '1px solid rgba(255,255,255,0.08)',
                }}>
                  {seg.tooltip || `${segName} — noch nicht aktiviert`}
                </div>
              )}
            </div>
          );
        })}
      </div>

      {/* Keine Quelle ueber Schwelle */}
      {activeCount === 0 && (
        <div style={{
          marginTop: 10,
          fontSize: 12,
          color: 'rgba(251,191,36,0.7)',
          lineHeight: 1.5,
        }}>
          Keine Signalquelle über der Anonymitätsschwelle.
        </div>
      )}

      {/* S1-only hint */}
      {isS1Only && (
        <div style={{
          marginTop: 10,
          fontSize: 12,
          color: 'rgba(251,191,36,0.7)',
          lineHeight: 1.5,
        }}>
          MPI-Score basiert aktuell nur auf Kulturumfrage-Daten.
        </div>
      )}
    </div>
  );
}
